// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"3a1ad11c276f1ddc2ba4","966":"3954d0ff848daf37a82e"}[chunkId] + ".js";
};